import { SeatMapCabin } from "src/types/SeatMap";

export const hasWings = (cabin: SeatMapCabin, rowIndex: number) =>
  Boolean(
    cabin.wings &&
      cabin.wings.first_row_index <= rowIndex &&
      cabin.wings.last_row_index >= rowIndex
  );
;
import "/Users/igor/Duffel/ancillaries-component/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";